(() => {
  'use strict';
  const root = document.querySelector('[data-nll-purchase]');
  const source = root?.querySelector('[data-nll-subscription-data]');
  if (!source) return;
  let data;
  try { data = JSON.parse(source.textContent); } catch { return; }
  const money = cents => new Intl.NumberFormat(data.locale, {
    style: 'currency', currency: data.currency, maximumFractionDigits: 2,
    minimumFractionDigits: Number.isInteger(cents / 100) ? 0 : 2
  }).format(cents / 100);
  const setText = (node, text) => {
    if (node && node.textContent !== text) node.textContent = text;
  };
  const create = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const syncPackageLinks = isSubscription => {
    root.querySelectorAll('[data-nll-subscription-url]').forEach(link => {
      const target = isSubscription ? link.dataset.nllSubscriptionUrl : link.dataset.nllOneTimeUrl;
      if (target && link.getAttribute('href') !== target) link.setAttribute('href', target);
      const unit = isSubscription ? link.dataset.nllSubscriptionUnit : link.dataset.nllOneTimeUnit;
      if (unit) setText(link.querySelector('[data-nll-package-unit]'), unit);
    });
    setText(root.querySelector('[data-nll-package-price-note]'), isSubscription ? data.labels.packageSubscription : data.labels.packageOnce);
  };
  const syncProductForm = (isSubscription, planId) => {
    root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
      const controls = Array.from(form.elements).filter(control => control.name === 'selling_plan');
      const nativeControl = controls.find(control => !control.hasAttribute('data-nll-selling-plan'));
      const ownControl = controls.find(control => control.hasAttribute('data-nll-selling-plan'));
      if (nativeControl && nativeControl.type !== 'hidden') {
        ownControl?.remove();
        return;
      }
      let target = nativeControl || ownControl;
      if (!target) {
        target = document.createElement('input');
        target.type = 'hidden';
        target.name = 'selling_plan';
        target.setAttribute('data-nll-selling-plan', '');
        form.append(target);
      }
      if (nativeControl && ownControl) ownControl.remove();
      target.value = isSubscription ? String(planId) : '';
      target.disabled = !isSubscription;
    });
  };
  const stickyButton = document.querySelector('[data-nll-sticky-submit]');
  const stickyError = document.querySelector('[data-nll-sticky-error]');
  let observedSubmit;
  let observedError;
  const stateObserver = new MutationObserver(() => syncSticky());
  const syncSticky = () => {
    if (!stickyButton) return;
    const form = stickyButton.form;
    const submit = form?.querySelector('[data-submit-button]');
    const error = root.querySelector('[data-error-message-wrapper]');
    if (submit !== observedSubmit || error !== observedError) {
      stateObserver.disconnect();
      if (submit) stateObserver.observe(submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      if (error) stateObserver.observe(error, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
      observedSubmit = submit;
      observedError = error;
    }
    const variantId = root.querySelector('[data-main-product-id]')?.value;
    const variant = data.variants.find(item => String(item.id) === variantId) || data.variants[0];
    const choice = root.querySelector('.appstle_subscription_wrapper input[type="radio"][name="selling_plan"]:checked');
    const ready = variant && (!variant.allocations.length || Boolean(choice));
    const busy = submit?.classList.contains('loading') || submit?.getAttribute('aria-disabled') === 'true';
    stickyButton.disabled = !submit || submit.disabled || !ready || busy;
    stickyButton.setAttribute('aria-busy', busy ? 'true' : 'false');
    setText(stickyButton, submit?.disabled ? stickyButton.dataset.nllSoldOutLabel : stickyButton.dataset.nllLabel);
    const message = error && !error.hidden ? error.querySelector('[data-error-message]')?.textContent.trim() : '';
    if (stickyError) {
      setText(stickyError, message || '');
      stickyError.hidden = !message;
    }
  };
  const reconcile = () => {
    const variantId = root.querySelector('[data-main-product-id]')?.value;
    const variant = data.variants.find(item => String(item.id) === variantId) || data.variants[0];
    if (!variant) return;
    root.querySelectorAll('.appstle_subscription_wrapper').forEach(widget => {
      const subscriptionRadio = widget.querySelector('.payAsYouGoPlansDropdownWrapper input[name="selling_plan"]')
        || widget.querySelector('.appstle_include_dropdown input[type="radio"][name="selling_plan"]');
      const onceRadio = widget.querySelector('input[type="radio"][name="selling_plan"][value=""]');
      const subCard = subscriptionRadio?.closest('.appstle_subscription_wrapper_option');
      const onceCard = onceRadio?.closest('.appstle_subscription_wrapper_option');
      if (!subCard) return;
      const planId = subscriptionRadio.value;
      const allocation = variant.allocations.find(item => String(item.id) === String(planId));
      if (!allocation || !Number.isFinite(allocation.price)) return;
      widget.classList.add('nll-subscription-options');
      subCard.classList.add('nll-subscription-option');
      onceCard?.classList.add('nll-onetime-option');
      if (subCard.parentElement === widget && widget.firstElementChild !== subCard) widget.prepend(subCard);
      subCard.classList.toggle('nll-option-selected', subscriptionRadio.checked);
      onceCard?.classList.toggle('nll-option-selected', Boolean(onceRadio?.checked));
      setText(subCard.querySelector('.appstle_subscribe_save_text'), data.labels.subscribe);
      setText(onceCard?.querySelector('.appstle_one_time_text'), data.labels.once);
      let banner = subCard.querySelector('.nll-subscription-banner');
      if (!banner) {
        banner = create('div', 'nll-subscription-banner');
        subCard.prepend(banner);
      }
      let summary = subCard.querySelector('.nll-subscription-summary');
      if (!summary) {
        summary = create('div', 'nll-subscription-summary');
        const priceDetail = create('div', 'nll-subscription-price-detail');
        priceDetail.append(create('div', 'nll-subscription-unit'), create('span', 'nll-subscription-discount'));
        summary.append(priceDetail);
        const saving = create('div', 'nll-subscription-saving');
        saving.setAttribute('aria-live', 'polite');
        summary.append(saving, create('p', 'nll-subscription-compare', data.labels.compare));
        const benefits = create('ul', 'nll-subscription-benefits');
        benefits.append(create('li', '', data.labels.best), create('li', '', data.labels.recurring));
        summary.append(benefits, create('p', 'nll-subscription-baseline'));
        const frequency = subCard.querySelector('.appstle_subscribe_option_grid');
        const frequencyContainer = subCard.querySelector('.appstle_subscribe_option');
        if (frequencyContainer?.parentElement === subCard) subCard.insertBefore(summary, frequencyContainer);
        else if (frequency && frequency.parentElement === subCard) subCard.insertBefore(summary, frequency);
        else subCard.append(summary);
      }
      const reference = data.singlePrice * data.quantity;
      const percent = reference > 0 ? Math.max(0, Math.round((reference - allocation.price) * 100 / reference)) : 0;
      const savingAmount = Math.max(0, variant.price - allocation.price);
      setText(banner, percent > 0 ? data.labels.banner.replace('[percent]', percent) : data.labels.subscribe);
      const discount = summary.querySelector('.nll-subscription-discount');
      setText(discount, (data.labels.discount || data.labels.banner).replace('[percent]', percent));
      discount.hidden = percent <= 0;
      setText(summary.querySelector('.nll-subscription-unit'), money(allocation.price / data.quantity) + ' ' + data.labels.perBag);
      const savingNode = summary.querySelector('.nll-subscription-saving');
      setText(savingNode, data.labels.save.replace('[amount]', money(savingAmount)));
      savingNode.hidden = savingAmount <= 0;
      summary.querySelector('.nll-subscription-compare').hidden = savingAmount <= 0;
      const baseline = summary.querySelector('.nll-subscription-baseline');
      const baselineLabel = data.quantity === 1 ? data.labels.baselineOne : data.labels.baseline;
      setText(baseline, baselineLabel.replace('[count]', data.quantity).replace('[price]', money(data.singlePrice)));
      baseline.hidden = percent <= 0;
      root.querySelectorAll('[data-nll-onetime-note], [data-nll-onetime-payment]').forEach(node => { node.hidden = subscriptionRadio.checked; });
      root.querySelectorAll('[data-nll-subscription-note], [data-nll-subscription-payment]').forEach(node => { node.hidden = !subscriptionRadio.checked; });
      syncPackageLinks(subscriptionRadio.checked);
      syncProductForm(subscriptionRadio.checked, planId);
    });
    syncSticky();
  };
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; reconcile(); });
  };
  new MutationObserver(queue).observe(root, { childList: true, subtree: true });
  root.addEventListener('change', queue);
  root.addEventListener('click', queue);
  root.addEventListener('submit', reconcile, true);
  reconcile();
})();
